export const kmongLink =
  'https://kmong.com/@%EC%9D%B8%ED%84%B0%EB%9E%99%ED%8B%B0%EB%B8%8C%EB%94%94%EB%B2%A8%EB%A1%9C%ED%8D%BC';
